import ApiService from "../../../services/api.service";

export default {
  createFeed({ commit, state }, payload) {
    // Destructure 'state' from context
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);
    return new Promise((resolve, reject) => {
      ApiService.setAuthorizationHeader();
      ApiService.post(`discover/post/create/`, payload)
        .then((response) => {
          // commit('ADD_POST_TO_FEED_AND_MY_ACTIVITY', response.data)
            resolve(response);
        })
        .catch((err) => {
          commit("SET_ERROR", err);
          reject(err);
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    });
  },
  uploadFeedPhotoMedia(_, payload) {
    ApiService.setAuthorizationHeader();
    return new Promise((resolve, reject) => {
      ApiService.post("media-upload/create/", payload)
        .then((response) => {
          if (response.status === 201) {
            resolve(response);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  deleteFeedPhotoMedia(_, mediaId) {
    ApiService.setAuthorizationHeader();
    return new Promise((resolve, reject) => {
      ApiService.delete(`media-upload/${mediaId}/delete/`)
        .then((response) => {
          if (response.status === 200 || response.status === 204) {
            resolve(response);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchFeedList({ commit, state, dispatch, rootGetters }) {
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);
    let url = `discover/post/list/?ordering=-created_at&page=${state.feedPage}&page_size=10`
    if (rootGetters['profile/selectedUser']?.id !== rootGetters['profile/userInformation']?.id)
      url+= `&user_id=${rootGetters['profile/selectedUser']?.id}`
    return new Promise((resolve, reject) => {
      ApiService.setAuthorizationHeader();
      ApiService.get(url)
        .then((response) => {
          if (response.status === 200) {
            commit("SET_FEEDS", response.data.results);
            response.data.next ? dispatch('setHasMoreFeedPage', 'remaining')  : dispatch('setHasMoreFeedPage', 'exceeded') 
            resolve();
          } 
        })
        .catch((err) => {
          commit("SET_ERROR", err);
          reject(err);
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    });
  },
  async deleteFeed({commit}, payload) {
    return await new Promise((resolve, reject) => {
      ApiService.delete(`discover/post/${payload}/delete/`)
        .then((response) => {
          commit('DELETE_POST_FROM_ACTIVITY_AND_FEED', payload)
            resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getFollowed(context, payload) {
    const user_id = context.rootGetters['profile/selectedUser']?.id ?? context.rootGetters['profile/userInformation']?.id
    return new Promise((resolve, reject) => {
      ApiService.get(`user/following-users/?user_id=${user_id}&relation=${payload.relation}`)
        .then((response) => {
          if (response.status === 200) {
            if(payload.relation==='followers'){
              context.commit("setFollowed", response.data.results);
            }else{
              context.commit("SET_ALL_CONTRIBUTORS", response.data.results.map(contributor=>({...contributor, isLoading:false})))
            }
            resolve(response);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getFollowedOrgs(context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.get(
        `organization/following-organizations/?user_id=${payload.id}`
      )
        .then((response) => {
          if (response.status === 200) {
            context.commit("SET_FOLLOWED_ORGS", response.data.results);
            resolve(response);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  postFeedReaction(context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(
        `discover/post/${payload.post_id}/post-reaction/create/`,{reaction:payload.reaction}
      )
        .then((response) => {
          if (response.status === 201) {
            context.commit("feedReaction", response.data);
            resolve(response);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  deleteFeedReaction(context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.delete(
        `discover/post/${payload.post_id}/post-reaction/delete/`
      )
        .then((response) => {
          if (response.status === 200) {
            context.commit("feedReaction", response.data);
            resolve(response);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  addContributor({dispatch}, payload) {
    return new Promise((resolve, reject) => {
        ApiService.post(
          'contributor/create/',payload
        )
          .then((response) => {
              dispatch('updateFeedPageSize', 1)
              dispatch('fetchFeedList')
              resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
    });
  },
  setScrollHeight({commit}, scrollHeight){
    commit("SET_SCROLL_HEIGHT", scrollHeight)
  },
  incrementFeedPageSize({commit, state}) {
    commit('SET_FEED_PAGE_SIZE', state.feedPage+1)
  },
  updateFeedPageSize({ commit, state }, payload) {
    if (payload && typeof payload === 'number') {
      commit('SET_FEED_PAGE_SIZE', payload);
    } else {
      const newPage = state.feedPage + 1;
      commit('SET_FEED_PAGE_SIZE', newPage);
    }
  },
  setHasMoreFeedPage({commit}, limit){
    commit("SET_HAS_MORE_PAGES", limit)
  },
  fetchFeedReactedUsers(_, payload) {
    return new Promise((resolve, reject) => {
      ApiService.get(`discover/post/${payload.post_id}/post-reaction/detail/`)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchRecommendedConnections({commit}){
      return new Promise((resolve, reject)=>{
        ApiService.get(`user/friends/recommended/users/`)
        .then((response) => {
          commit('SET_RECOMMENDED_CONNECTIONS', response.data.results)
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
      })
  },
  fetchRecommendedOrganization({commit}){
    return new Promise((resolve, reject)=>{
      ApiService.get(`user/friends/recommended/organizations/`)
      .then((response) => {
        commit('SET_RECOMMENDED_ORGANIZATIONS', response.data.results)
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
    })
},
  fetchActivity({commit, state, dispatch, rootGetters}, {type}){
    const user_id = rootGetters['profile/userInformation']?.id
    return new Promise((resolve, reject)=>{
      const url = type === 'post' ? 'discover/network-feed-activity/list/' : 'discover/network-feed-comment-activity/list/' 
      const page = type === 'post' ? state.activityPage : state.commentPage
      ApiService.get(`${url}?user_id=${user_id}&page_size=${5}&page=${page}&ordering=-created_at`)
      .then((response) => {
        commit(`SET_ACTIVITY_${type.toUpperCase()}`, response.data.results)
        if (type === 'post'){
          response.data.next ? dispatch('updateActivityOrCommentPageLimit', {type:'myactivity', limit:'remaining'}) : dispatch('updateActivityOrCommentPageLimit', {type:'myactivity', limit:'exceeded'}) 
        }
        else if (type === 'comment'){
          response.data.next ? dispatch('updateActivityOrCommentPageLimit', {type:'comment', limit:'remaining'}) : dispatch('updateActivityOrCommentPageLimit', {type:'comment', limit:'exceeded'}) 
        }
        resolve(response);
      })
      .catch((err) => {
        if (type === 'post' && state.activityPage > 1)
          dispatch('incOrDecActivityOrCommentPageCounter', {type:'myactivity', action:'dec'})
        else if (type === 'comment' && state.commentPage > 1)
          dispatch('incOrDecActivityOrCommentPageCounter', {type:'myactivity', action:'dec'})
      
        reject(err);
      });
    })
  },

  createFeedComments({commit, state}, {postId, payload}){
    return new Promise((resolve, reject)=>{
      ApiService.post(`discover/post/comment/${postId}/create/`, payload)
      .then((response) => {
        const {data} = response
        if (!data?.parent)
          state.feedComments.unshift(data)
        else 
          state.feedComments.map(comment=>{
              return comment?.id === data?.parent ?
              {
                ...comment,
                child: comment?.child.unshift(data)
              }
              :
              {
                ...comment
              } 
              
          })
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
    })
  },
  
  fetchContributorsAndOrganizations({commit, rootGetters}, {relation='contributors', account_type='basic', user_id = ''}){
    const selectedUserId = user_id ? user_id : rootGetters['profile/selectedUser']?.id
    let url = `contributor/list/?relation=${relation}&account_type=${account_type}&user_id=${selectedUserId}`
    ApiService.setAuthorizationHeader();
    return new Promise((resolve, reject)=>{
      ApiService.get(url)
      .then((response) => {
        if ( account_type === 'basic' )
          relation === 'contributors' ? commit("setFollowed", response.data.results) : commit("SET_ALL_CONTRIBUTORS", response.data.results.map(contributor=>({...contributor, isLoading:false})))
        else if (account_type === 'organization'){
          relation === 'contributors' ? commit("SET_FOLLOWED_ORGS", response.data.results) : commit('SET_ALL_ORGANIZATION', response.data.results.map(contributor=>({...contributor, isLoading:false})))
        }
        resolve(response)
      })
      .catch((err) => {
        reject(err);
      });
    })
  },
  toggleLoadingFollowedOrgsState({state}, payload=null){
    const toggleState = payload ?? !state.loadingFollowers
    state.loadingFollowedOrgs = toggleState
  },
  toggleLoadingFollowersState({state}, payload=null){
    const toggleState = payload ?? !state.loadingFollowers
    state.loadingFollowers = toggleState
  },
  toggleActivityLoader({state}){
    state.activityLoader = !state.activityLoader
  },

  fetchComments({commit}, {postId}){
    return new Promise((resolve, reject)=>{
      const pageSize=10
      const page=1
      ApiService.get(`discover/post/comment/${postId}/list/?ordering=-created_at&page=${page}&page_size=${pageSize}`)
      .then((response) => {
        commit("SET_FEED_COMMENTS", response.data.results)
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
    })
  },

  deleteComments({commit, state}, {postId, commentId}){
    return new Promise((resolve, reject)=>{
      ApiService.delete(`discover/post/comment/${postId}/${commentId}/delete/`)
      .then((response) => {
        
        state.feedComments = state.feedComments?.map(comment=>{
          if (comment?.id !== commentId)
            return {
              ...comment,
              child: comment?.child?.filter(comment=>comment?.id !== commentId)
            } 
        }).filter(comment=>comment)
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
    })
  },

  editComments({commit, state}, {postId, commentId, text, parent} ){
    return new Promise((resolve, reject)=>{
      ApiService.patch(`discover/post/comment/${postId}/${commentId}/update/`, {text, parent})
      .then((response) => {
        const {data} = response
        state.feedComments = state.feedComments.map(comment=>{
            if (data?.parent){
              if (comment?.id === data?.parent){
                return {
                  ...comment,
                  child: comment.child.map(childComment=>{
                    return childComment?.id === data?.id ?
                    {
                      ...data
                    } :
                    {
                      ...childComment
                    }

                  })
                }
              }
              else{
                return {...comment}
              }
            
            }
            else if (!data?.parent){
              return comment?.id === data?.id ?
              {
                ...data
              } 
              :
              {
                ...comment
              }
            }
          })
                
        // })
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
    })
  },

  likeDislikeComments({state}, {commentId, action}){
    return new Promise((resolve, reject)=>{
      ApiService.post(`discover/post/comment/${commentId}/action/create/`, {'action': action})
      .then((response) => {
        const {data} = response
        state.feedComments = state.feedComments.map(comment=>{
            if (data?.parent){
              if (comment?.id === data?.parent){
                return {
                  ...comment,
                  child: comment.child.map(childComment=>{
                    return childComment?.id === data?.id ?
                    {
                      ...data
                    } :
                    {
                      ...childComment
                    }

                  })
                }
              }
              else{
                return {...comment}
              }
            
            }
            else if (!data?.parent){
              return comment?.id === data?.id ?
              {
                ...data
              } 
              :
              {
                ...comment
              }
            }
        })

                
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
    })
  },
  deleteLikeDislikeComments({state}, {commentId}){
    return new Promise((resolve, reject)=>{
      ApiService.delete(`discover/post/comment/${commentId}/action/delete/`)
      .then((response) => {
        const {data} = response
        state.feedComments = state.feedComments.map(comment=>{
            if (data?.parent){
              if (comment?.id === data?.parent){
                return {
                  ...comment,
                  child: comment.child.map(childComment=>{
                    return childComment?.id === data?.id ?
                    {
                      ...data
                    } :
                    {
                      ...childComment
                    }

                  })
                }
              }
              else{
                return {...comment}
              }
            
            }
            else if (!data?.parent){
              return comment?.id === data?.id ?
              {
                ...data
              } 
              :
              {
                ...comment
              }
            }
        })
                
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
    })
  },
  followRecommendedOrganization(_, {organizationId}){
    return new Promise((resolve, reject)=>{
      ApiService.post(`organization/${organizationId}/follow/`, {})
      .then((res) => {
        resolve(res)
      })
      .catch(err=>{
        reject(err)
      })
  })
  },
  sharePost(_, {postId, sharedList}){
    ApiService.setAuthorizationHeader();
    return new Promise((resolve, reject)=>{
      ApiService.post(`discover/post/${postId}/share/`, sharedList)
      .then((response) => {
        resolve(response)
      })
      .catch((err) => {
        reject(err);
      });
    })
  },
  setSharedPostId({commit}, postId){
    commit('SET_SHARED_POST_ID', postId)
  },
  fetchIndividualPost({state}, {sharedPostId = null}){
    const postId = sharedPostId ?? state.sharedPostId
    console.log(postId)
    ApiService.setAuthorizationHeader();
    return new Promise((resolve, reject)=>{
      ApiService.get(`discover/post/${postId}/detail/`)
      .then((response) => {
        console.log(response, "response")
        resolve(response.data)
      })
      .catch((err) => {
        reject(err);
      });
    })
  },

  incOrDecActivityOrCommentPageCounter({commit, state}, { type = 'myactivity', action='inc' }){
    const mutationType = type === 'myactivity' ? 'ACTIVITY' : 'COMMENT'
    const counter = type === 'myactivity' ? state.activityPage:   state.commentPage
    const value = action === 'inc' ? 1 : -1
    commit(`UPDATE_${mutationType}_PAGE_COUNTER`, counter+value)
  },
  resetActivityOrCommentPageCounter({commit}, { type = 'myactivity' }){
    const mutationType = type === 'myactivity' ? 'ACTIVITY' : 'COMMENT'
    commit(`UPDATE_${mutationType}_PAGE_COUNTER`, 1)
  },
  updateActivityOrCommentPageLimit({commit}, { type = 'myactivity', limit = 'exceeded' }){
    const mutationType = type === 'myactivity' ? 'ACTIVITY' : 'COMMENT'
    commit(`SET_${mutationType}_PAGE_LIMIT`, limit)
  },

  setActiveKey({commit}, activeKeyDetails={}){
    commit("SET_ACTIVE_KEY", activeKeyDetails)
  },
  
  filterReportedDocumentFeed({state}, documentId){
    const feeds = state.feeds.filter(feed=>feed?.id !== documentId)
    state.feeds = [...feeds]
  },

  editFeedPost(_, payload){
    ApiService.setAuthorizationHeader();
    return new Promise((resolve, reject)=>{
      ApiService.patch(`discover/post/${payload.postId}/update/`, payload?.postDetails)
      .then((response) => {
        console.log(response, "response")
        resolve(response.data)
      })
      .catch((err) => {
        reject(err);
      });
    })
  },

  addPostToState({commit}, post) {
    commit('ADD_POST_TO_FEED_AND_MY_ACTIVITY', post)
  } 
};
